var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_204_12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.935933 9.02143C1.07422 10.2552 2.07703 11.2347 3.31708 11.2945C4.17418 11.3357 5.04974 11.3572 6 11.3572C6.95026 11.3572 7.82582 11.3357 8.68295 11.2945C9.92297 11.2347 10.9257 10.2552 11.0641 9.02143C11.1572 8.19057 11.2336 7.33876 11.2336 6.47103C11.2336 5.60331 11.1572 4.7515 11.0641 3.92066C10.9257 2.6869 9.92297 1.70732 8.68295 1.64759C7.82582 1.60631 6.95026 1.58486 6 1.58486C5.04974 1.58486 4.17418 1.60631 3.31708 1.64759C2.07703 1.70732 1.07422 2.6869 0.935933 3.92066C0.842807 4.7515 0.766403 5.60331 0.766403 6.47103C0.766403 7.33876 0.842808 8.19057 0.935933 9.02143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07439 0.642857V2.8193",
    stroke: "#FF0000",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91982 0.642857V2.8193",
    stroke: "#FF0000",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8585 4.71429L1.14154 4.71428L1.27794 2.20282L5.94273 1.86448L10.8585 2.20282V4.71429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.935933 9.02143C1.07422 10.2552 2.07703 11.2347 3.31708 11.2945C4.17418 11.3357 5.04974 11.3572 6 11.3572C6.95027 11.3572 7.82582 11.3357 8.68295 11.2945C9.92297 11.2347 10.9257 10.2552 11.0641 9.02143C11.1572 8.19057 11.2336 7.33876 11.2336 6.47103C11.2336 5.60331 11.1572 4.7515 11.0641 3.92066C10.9257 2.6869 9.92297 1.70732 8.68295 1.64759C7.82582 1.60631 6.95027 1.58486 6 1.58486C5.04974 1.58486 4.17418 1.60631 3.31708 1.64759C2.07703 1.70732 1.07422 2.6869 0.935933 3.92066C0.842807 4.7515 0.766403 5.60331 0.766403 6.47103C0.766403 7.33876 0.842808 8.19057 0.935933 9.02143Z",
    stroke: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.01684 4.71429H11.0347",
    stroke: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarErrorIcon);
export default __webpack_public_path__ + "static/media/CalendarErrorIcon.0a37e4881d70ddd4e225cde35ec7fa6e.svg";
export { ForwardRef as ReactComponent };